import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import ServicesHero from "./components/ServicesHero";
import ServiceDetailCards from "./components/ServiceDetailCards";
import ComparisonSection from "./components/ComparisonSection";
import ServicesCTA from "./components/ServicesCTA";

export default function ServicesPage() {
  return (
    <div className="bg-[#09090B] min-h-screen">
      <link
        href="https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600;700;800&family=Inter:wght@400;500;600&display=swap"
        rel="stylesheet"
      />
      <Navbar />
      <main>
        <ServicesHero />
        <ServiceDetailCards />
        <ComparisonSection />
        <ServicesCTA />
      </main>
      <Footer />
    </div>
  );
}
